import {
  ButtonGroup,
  Card,
  CardBody,
  HStack,
  Icon,
  Table,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import DeleteStateDialog from '@/components/Dialogs/DeleteStateDialog';
import StyledButton from '@/components/ui/styledButton';
import { useAppSelector } from '@/lib/hooks';
import { ExternalLink } from 'react-feather';
import { useSystemTheme } from '@/lib/ThemeSwitcher';

export default function SettingsPage() {
  const stateID = useAppSelector((state) => state.viewReducer.id);
  const project = useAppSelector((state) => state.viewReducer);

  const { mode, setMode } = useSystemTheme();
  
  const {
    open: isDeleteDialogOpen,
    onOpen: onDeleteDialogOpen,
    onClose: onDeleteDialogClose,
  } = useDisclosure();

  return (
    <VStack width="100%" height="100%" alignItems="start" p={4} gap={8}>
      <VStack alignItems="start">
        <Text fontSize="16pt">Profile</Text>
        <Card.Root borderRadius="0.375rem" borderWidth={0} backgroundColor="accentButtonDefault">
          <CardBody
            borderRadius="0.375rem"
            _hover={{
              bg: 'accentButtonHover',
              transition: 'background-color 0.2s',
              cursor: 'pointer',
            }}
            onClick={() =>
              window
                .open(
                  `https://auth.meshr.org/realms/${process.env.REACT_APP_AUTH_REALM}/account/`,
                  '_blank',
                )
                ?.focus()
            }
          >
            <HStack gap={4}>
              <Text color="cardDefault">Go to user settings</Text>
              <Icon color="cardDefault">
                <ExternalLink />
              </Icon>
            </HStack>
          </CardBody>
        </Card.Root>
      </VStack>

      <VStack alignItems="start">
        <Text fontSize="16pt">Themes</Text>
        <ButtonGroup>
          <StyledButton
            disabled={mode === 'light'}
            variant="solid"
            text="Light Mode"
            onClick={() => setMode('light')}
          />
          <StyledButton
            disabled={mode === 'dark'}
            variant="solid"
            text="Dark Mode"
            onClick={() => setMode('dark')}
          />
          <StyledButton
            disabled={mode === 'festive'}
            variant="solid"
            text="Festive Mode"
            onClick={() => setMode('festive')}
          />
          <StyledButton variant="solid" text="Eric Mode" onClick={() => setMode('eric')} />
        </ButtonGroup>
      </VStack>

      <VStack alignItems="start" gap={4}>
        <Text fontSize="16pt">Project </Text>

        <Table.Root
          variant="simple"
          borderRadius="0.375rem"
          borderColor="midCardBG"
          backgroundColor="cardDefault"
        >
          <Table.Body>
            <Table.Row>
              <Table.Cell>
                <Text color="primaryText">Name:</Text>
              </Table.Cell>
              <Table.Cell>
                <Text overflowX="hidden" textOverflow="clip" color="primaryText" fontStyle="italic">
                  {project.name}
                </Text>
              </Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell>
                <Text color="primaryText">Folders:</Text>
              </Table.Cell>
              <Table.Cell>
                <Text color="primaryText" fontStyle="italic">
                  {Object.keys(project.documents.structure.FOLDER).length}
                </Text>
              </Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell>
                <Text color="primaryText">Graphs:</Text>
              </Table.Cell>
              <Table.Cell>
                <Text color="primaryText" fontStyle="italic">
                  {Object.keys(project.documents.structure.GRAPH).length}
                </Text>
              </Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell colSpan={3}>
                <StyledButton
                  fillWidth
                  variant="danger"
                  text="Delete project data"
                  onClick={() => onDeleteDialogOpen()}
                />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table.Root>
      </VStack>

      <DeleteStateDialog
        isOpen={isDeleteDialogOpen}
        onClose={onDeleteDialogClose}
        stateId={stateID}
      />
    </VStack>
  );
}
